<div class="dedup-warning-modal">
  <h2 mat-dialog-title>Some members were already contacted</h2>
  <mat-dialog-content>
    <p class="mat-body-2">
      It looks like {{data.previously_contacted}} people on your list have already received this message. Would you like to skip them or send it again to everyone?
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="sendToNewOnly()">
      Skip duplicates
    </button>
    <button mat-stroked-button color="primary" (click)="resendToAll()">
      Send to everyone
    </button>
    <button mat-button (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
